module.exports = __webpack_public_path__ + "static/media/banner_jcytl.378c6b15.png";